import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ACOES, IMAGES } from "@/data/site";

const EASE = [0.76, 0, 0.24, 1];

const Card = ({ n, title, desc, image, span, delay }) => (
    <motion.article
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
        data-testid={`acao-card-${n}`}
        className={`group relative overflow-hidden border border-white/10 bg-white/[0.02] ${span}`}
    >
        {image && (
            <div className="absolute inset-0 -z-0">
                <img
                    src={image}
                    alt={title}
                    className="h-full w-full object-cover opacity-40 transition-transform duration-[900ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-[var(--ink)]/40 to-transparent" />
            </div>
        )}
        <div className="relative z-10 flex h-full flex-col p-6 md:p-8 min-h-[280px] md:min-h-[380px]">
            <div className="flex items-start justify-between">
                <span className="font-display text-[12px] tracking-[0.32em] text-[var(--sun)]">
                    {n}
                </span>
                <ArrowUpRight
                    size={22}
                    className="text-white/60 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[var(--sun)]"
                />
            </div>

            <div className="mt-auto pt-8">
                <h3 className="font-editorial italic text-3xl md:text-4xl text-white leading-tight">
                    {title}
                </h3>
                <p className="mt-4 font-body text-[14px] leading-relaxed text-white/70 max-w-md">
                    {desc}
                </p>
            </div>
        </div>
    </motion.article>
);

export const Acoes = () => {
    const layout = [
        { ...ACOES[0], image: IMAGES.training, span: "md:col-span-8", delay: 0 },
        { ...ACOES[1], image: null, span: "md:col-span-4", delay: 0.08 },
        { ...ACOES[2], image: null, span: "md:col-span-4", delay: 0.16 },
        {
            ...ACOES[3],
            image: IMAGES.community,
            span: "md:col-span-8",
            delay: 0.24,
        },
    ];

    return (
        <section
            id="acoes"
            data-testid="acoes-section"
            className="relative bg-[var(--ink)] text-white py-24 md:py-32"
        >
            <div className="container-x">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-20">
                    <div className="col-span-12 md:col-span-7">
                        <div className="flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-white/50 font-body">
                            <span className="inline-block h-px w-10 bg-white/40" />
                            <span>Seção 02</span>
                        </div>
                        <h2
                            data-testid="acoes-title"
                            className="font-display text-[13vw] md:text-[7vw] lg:text-[6vw] mt-6"
                        >
                            Nossas <br />
                            <span className="font-editorial italic font-medium text-[var(--sun)]">
                                ações.
                            </span>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:col-start-9 flex items-end">
                        <p className="font-body text-[15px] leading-relaxed text-white/70">
                            Quatro frentes que caminham juntas — do treino
                            técnico ao cuidado com o corpo, da cultura à
                            solidariedade.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {layout.map((c) => (
                        <Card key={c.n} {...c} />
                    ))}
                </div>
            </div>
        </section>
    );
};
